<template>
    <div>
    <div class="loginConnecte" v-if="$store.getters.getUser!=null && !$isAnonyme()">
      <div style="float:right;padding: 10px">
      <s-button theme="is-danger" label="Se déconnecter" @onclick="$emit('logout')"/>
      </div>
      <div class="Stitle">
          Vous êtes connecté {{$store.getters.getUser.displayName}}
      </div>
      <div class="SSubtitle">
          Votre email de connexion est {{$store.getters.getUser.email}}
      </div>
      <div style="width: 100%;text-align:center;padding-top: 20px">
        <s-button theme="is-success is-medium" label="DEMARRER" @onclick="$emit('club')"/>
      </div>
    </div>
    <div :class="!notModal ? 'login' : ''" v-show="$store.getters.getUser==null || $isAnonyme()">
      
        <div :class="!notModal ? 'connectByGafa' : 'connectByGafaModal'"> 
          
          <div style="text-align:center">
          <div class="buttonOAuth">
            <a class="button is-google is-outlined is-info is-rounded is-medium"  
              style="width:320px;margin: 10px;"
              @click="loginWithGoogle">
              <span class="icon">
                <i class="fab fa-google"></i>
              </span>
              <span>Se connecter par Google</span>
            </a>
           
            <br />
            
          </div>
        </div>
        </div><br/><br/>
        <div :class="!notModal ? 'loginPetank' : 'loginPetankModal'">
          <h1 class="Stitle" >
                Compte petanque-app.com :
              </h1>
            <p class="control has-icons-left " >
            <input type="text" placeholder="Email" class="input is-rounded is-success  is-normal" v-model="email"
            style="width: 300px"
            />
            <span class="icon is-small is-left">
                 <i class="fas fa-envelope"></i>
             </span>
            </p>
            <div class="error" v-if="errorEmail">
                Votre email est vide ou n'est pas au bon format
            </div>
            <div class="error" v-if="errorNOTFOUND">
                Email inconnu ...                 
            </div>
          <br/>
            <div style="display:inline-block;text-align:left;;margin-right:5px;vertical-align:middle">
              
            <p class="control has-icons-left has-icons-right" >
            <input :type="typePWD ? 'password':'text'" 
              class="input is-success is-rounded is-nomral"
              placeholder="Mot de passe" theme="is-success" v-model="password"
              style="width:280px"/>
             <span class="icon is-small is-left">
                 <i class="fas fa-lock"></i>
             </span>
            </p>
            </div>
             <div style="display:inline-block;vertical-align:middle;">
            <s-button @onclick="typePWD=!typePWD" 
              :theme="!typePWD ? 'is-success is-small' : 'is-light is-small '" icon="eye" label=""/>
             </div>
            <div class="error" v-if="errorPwd">
                Votre mot de passe doit contenir au moins 1 chiffre et doit être supérieur à 6 caractères
            </div>
            <div class="error" v-if="errorNotgoodPwd">
                Mauvais mot de passe ...
            </div>
        <div>
          <br/>
        
        <div style="width:100%;margin-top: 0px;">
          <div style="width:50%;display:inline-block">
          <s-button theme="is-loading is-small" label="" v-show="loadingSendMail"/>
          <a  v-on:click="resetPwd" class="resetpwd">Mot de passe oublié</a>
          </div>

          <div style="width:50%;display:inline-block">
            <s-button icon="sign-in-alt" label="Se loguer" :theme="themelogin" @onclick="login"
            /> &nbsp;
          </div>
        </div>
        
        </div>
        <div class="sendEmail" v-if="sendEmail">
              Un mail vous a été envoyé pour réinitialiser votre mot de passe
          </div>

        <div style="width: 100%">
          <div style="float:left;padding-right: -10%;padding-top: 10px">
            <s-button icon="user-plus" label="Créer votre compte" theme="is-primary  is-normal" @onclick="modalLoginCreate=true"/>
          </div>
          
        </div>
        <!-- /Notification -->
     
     
      </div>
      <!-- /Container -->
    </div>
    <s-modal
        title="Créer votre compte :"
        :open="modalLoginCreate"
        :close="true"
        @close="modalLoginCreate=false">
        <loginCreate @connect="connect" />
    </s-modal>
    <!-- /Hero Body -->
 </div>
</template>
<style scoped>
.SSubtitle {
    color: black;
    padding-left: 20px;
    font-size: 20px;
}
.connectByGafa {
  display: inline-block;
  width: 40%;
}
.connectByGafaModal {
  width: 100%;
  display: block;
}

/*LOGIN*/
@media screen and (max-width: 1025px) {
   .loginPetankModal {
    width: 100%;
    padding: 0px;
    margin-top: 0px;
    text-align: left;
    
    
  }
  .login {
    background-color: #FFD75C;
    margin-top: 800px;
    height: 670px;
    width: 100%;
  }
  .loginConnecte {
    background-color: #FFD75C;
    margin-top: 800px;
    height: 300px;
  }
  .loginPetank {
   
    padding: 10px;
   
    text-align: left;
   
    
  }
   
  .buttonOAuth {
      text-align:center; 
       
  }
}

@media screen and (min-width: 1025px) {
  .loginPetankModal {
    width: 100%;
    padding: 0px;
    margin-top: 10px;
    text-align: left;
    
    
  }
  .login {
    background-color: #FFD75C;
    height: 400px;
  }
  .loginConnecte {
    background-color: #FFD75C;
    height: 200px;
  }
  .loginPetank {
    padding: 10px;
    border-radius: 30px;
    text-align: left;
    float:right;
    padding-right: 20%;
  }
  .buttonOAuth {
    
    float: left;
    text-align: left; 
    padding-left: 20px;
  }
}
  .Stitle {
    padding-top: 10px;
    padding-left: 20px;   
    font-size: 20px;
    color: var(--bluebg);
    font-weight: bolder;
    padding-bottom: 20px;
  }
  
  .resetpwd {
    font-size: 14px;
    color: rgb(41, 55, 136);
  }
   .resetpwd:hover {
    font-size: 14px;
    color: rgb(17, 150, 17);
    
  }
  .buttonLogin {
    padding-top: 20px;
  }
  .error {
    color: rgb(112, 7, 7);
  }
  .sendEmail {
    color: rgb(11, 94, 24);
    font-weight: bolder;
    
  }
</style>
<script>
import firebase from "firebase/app";
import {FacebookAuthProvider} from "firebase/auth";
import keys from '@/firebase/keys_firebase'
import loginCreate from "@/views/auth/LoginCreate.vue"
export default {
  name: "login",
  props: ["notModal"],
  components: {
    loginCreate
  },
  data() {
    return {
      modalLoginCreate: false,
      errorEmail: false,
      errorNotgoodPwd: false,
      errorPwd: false,
      errorNOTFOUND: false,
      email: "",
      password: "",
      themelogin: "is-success is-normal",
      typePWD: true,
      sendEmail: false,
      loadingSendMail: false,
      keyCatpcha: null
    }
  },
  
  methods: {
    connect() {
      this.modalLoginCreate=false;
      this.$store.dispatch('init', ()=>{});
    },
     verifEmail() {
         if (this.email != "") {
              var reEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
              return !this.email.match(reEmail);
         }
         else 
          return false;

      },
      resetPwd() { 
        this.errorPwd =  false;
        this.errorNOTFOUND = false;
        this.sendEmail = false;
        this.errorEmail = false;
        this.loadingSendMail = true;
        this.errorNotgoodPwd = false;
        firebase.auth().sendPasswordResetEmail (this.email).then(()=>{
            this.loadingSendMail = false;
            this.sendEmail = true;
        }).catch(err=>{
          this.loadingSendMail = false;
          this.sendEmail = false;
          this.errorEmail = (err.code == "auth/invalid-email");
          this.errorNOTFOUND  = (err.code ==  "auth/user-not-found");
        })
      }
      ,
      verifPwd() {
         return !(this.password.match( /[0-9]/g) && 
                    (this.password.match( /[A-Z]/g) ||
                    this.password.match(/[a-z]/g)) && 
                    this.password.length >= 6)
      },
    verifyCaptcha(fct) {
      this.$sendRecaptcha( this.$recaptchaLoaded(), this.$recaptcha('login'), result=>{
          if (result.data.data.success) {
              fct();
          }
      })
    },
    async login() {
      this.errorEmail = this.verifEmail();
      this.errorPwd =  this.verifPwd();
      this.errorNOTFOUND = false;
      this.sendEmail = false;
      if (!this.errorEmail && !this.errorPwd) {
        this.themelogin = "is-success is-loading"
        const auth = await firebase.auth();
        this.verifyCaptcha(async ()=>{
            try {
              
                  await auth.signInWithEmailAndPassword(this.email, this.password);
                  this.$store.dispatch('init', ()=>{
                      this.themelogin = "is-success is-normal"
                      this.errorNotgoodPwd = false;
                      this.errorPwd = false;
                      this.errorEmail  = false;
                      this.email = "";
                      this.password = "";
                  });
               
            } catch (error) {
              
                if (error.code == "auth/invalid-email")
                  this.errorEmail = true;
                if (error.code == "auth/wrong-password")
                  this.errorNotgoodPwd = true;
                if (error.code == "auth/user-not-found")
                  this.errorNOTFOUND = true;
                this.themelogin = "is-success is-normal"
            }
            
        })
      } 
    },
   
    loginWithFacebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
           console.log(result);
           const credential = provider.credentialFromResult(result);
           const accessToken = credential.accessToken;
           console.log(result.user);
           this.$store.dispatch('init', ()=>{
                this.$emit("close");
           });
        })
        .catch(err => {
          // TODO:
         
          alert(err.message);
        });
    },
    loginWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
        
          this.$store.dispatch('init', ()=>{
              this.$emit("close");
          });
        })
        .catch(err => {
          // TODO:
          //alert(err.message);
         
        });
    },
    loginWithInstagram() {
      this.$router.replace("InstagramAuth");
    }
  }
};
</script>